import { fetchConToken } from "../helpers/fetch";
import { finishSpinner, startSpinner } from "./ui/spinner";
import { handleErrorApi } from "../helpers/randoms";
import { types } from "../types/types";

export const getCobraCoseguro = () => 
  async (dispatch) => {
    dispatch(startSpinner());
    dispatch({ type: types.startCobraCoseguro })
    try {
      const response = await fetchConToken("CobraCoseguro")
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.successCobraCoseguro,
          payload: body
        });
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({type: types.errorCobraCoseguro});
      handleErrorApi(dispatch, error, "Error al traer datos de Cobra Coseguro", "Ha ocurrido un error. Intente nuevamente");
    }
  }